var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"whirelab-input black--text text-body-2",attrs:{"value":_vm.value,"rules":_vm.rules,"append-icon":_vm.append_icon,"required":_vm.required,"readonly":_vm.readonly,"suffix":_vm.suffix,"type":_vm.type,"rounded":"","placeholder":_vm.placeholder},on:{"keyup":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }